import React from "react";
import { Icon } from "@iconify/react";
import { useDirection } from "../../../../contexts/DirectionContext";

interface FilterSectionProps {
  title: string;
  isCollapsed: boolean;
  onToggle: () => void;
  children: React.ReactNode;
  selectedValues?: string[];
}

export const FilterSection: React.FC<FilterSectionProps> = ({
  title,
  isCollapsed,
  onToggle,
  children,
  selectedValues = [],
}) => {
  const { isRTL } = useDirection();

  const renderSelectedValues = () => {
    if (selectedValues.length === 0) return null;
    if (selectedValues.length === 1) {
      return (
        <span
          className={`text-text-secondary/75 text-xs truncate font-normal ${
            isRTL ? "mr-2" : "ml-2"
          }`}
        >
          · {selectedValues[0]}
        </span>
      );
    }
    return (
      <span
        className={`text-text-secondary/75 text-xs truncate font-normal ${
          isRTL ? "mr-2" : "ml-2"
        }`}
      >
        · {selectedValues[0]} +{selectedValues.length - 1}
      </span>
    );
  };

  return (
    <div
      className="first:pt-4 pb-4 last:pb-0 [border-bottom:0.5px_solid_rgba(var(--colors-border-primary-rgb),0.5)] last:border-b-0"
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center text-sm font-semibold text-text-primary mb-3 hover:text-primary-500 transition-colors group"
      >
        <div className="flex items-center min-w-0">
          <span className="flex-shrink-0">{title}</span>
          {renderSelectedValues()}
        </div>
        <div className="flex-1" />
        <Icon
          icon={isCollapsed ? "ph:caret-down-thin" : "ph:caret-up-thin"}
          className="w-4 h-4 flex-shrink-0 text-text-secondary/75"
        />
      </button>
      <div className={`space-y-0.5 ${isCollapsed ? "hidden" : ""}`}>
        {children}
      </div>
    </div>
  );
};
